/* 2026-09-02 preview to cart shortcut.
   On product pages ADD TO CART only becomes visible after the Customer Canvas preview has been generated,
   and the preview opens a full-screen lightbox. On phones the buyer then has to find the 40px close button,
   scroll back and locate ADD TO CART (US mobile product-page add-to-cart rate was half of desktop's).
   While the lightbox is open this shows a fixed bar with "Looks good. Add to cart" that closes the lightbox
   and clicks the theme's real ADD TO CART button. No change to the Customer Canvas bundle. */
(function () {
  if (!document.querySelector('form[action*="/cart/add"], #ps-product-interface')) return;
  var bar = null, atc = null;

  function isVisible(el) { return !!el && el.getBoundingClientRect().width > 0; }
  function findAtc() {
    // Customer Canvas replaces the theme form with its own (#ps-product-interface); its ADD TO CART is button.ps-finish.
    var cc = document.querySelector('#ps-product-interface button.ps-finish, #ps-product-interface .ps-finish');
    if (cc) return cc;
    var all = Array.prototype.slice.call(document.querySelectorAll('button, input[type=submit]')).filter(function (b) {
      return /add to cart/i.test(b.innerText || b.value || '');
    });
    return all.filter(isVisible)[0] || all[0] || null;
  }
  function track(name, properties) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: name };
      Object.keys(properties || {}).forEach(function (key) { payload[key] = properties[key]; });
      window.dataLayer.push(payload);
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, properties || {});
      }
      if (window.psGa4Event) window.psGa4Event(name, properties || {});   // 2026-09-27 EXP-020: forward to GA4 (assets/ga4-funnel.js)
    } catch (e) {}
  }
  function closeLightbox() {
    var c = document.querySelector('.ReactModal__Content--after-open button[aria-label="Close lightbox"], button[aria-label="Close lightbox"]');
    if (c) c.click();
  }
  function build() {
    bar = document.createElement('div');
    bar.className = 'preview-cart-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add the previewed item to your cart');
    bar.innerHTML =
      '<button type="button" class="button button--primary preview-cart-bar__add">Looks good. Add to cart</button>' +
      '<button type="button" class="preview-cart-bar__edit">Change the name</button>';
    document.body.appendChild(bar);
    bar.querySelector('.preview-cart-bar__add').addEventListener('click', function () {
      var b = findAtc();
      closeLightbox();
      track('preview_bar_add_to_cart');
      var tries = 0;
      var go = function () {
        b = findAtc();
        if (isVisible(b)) { b.click(); return; }
        if (++tries < 40) { setTimeout(go, 200); return; }   // wait up to 8 s for the design to be ready
        if (b) b.scrollIntoView({ block: 'center', behavior: 'smooth' });
      };
      setTimeout(go, 250);
    });
    bar.querySelector('.preview-cart-bar__edit').addEventListener('click', function () {
      closeLightbox();
      var n = document.querySelector('input[name="first-name"]');
      if (n) setTimeout(function () { n.scrollIntoView({ block: 'center', behavior: 'smooth' }); n.focus(); }, 200);
    });
  }
  function directChildContaining(parent, descendant) {
    if (!parent || !descendant) return null;
    return Array.prototype.slice.call(parent.children).filter(function (child) {
      return child === descendant || child.contains(descendant);
    })[0] || null;
  }

  // Customer Canvas controls the form state. We leave its DOM order and field names untouched,
  // then use CSS order classes to make the required recipient name the first visual decision.
  function preparePersonalizationFlow() {
    var form = document.querySelector('#ps-product-form');
    var nameInput = form && form.querySelector('input[name="first-name"]');
    var flow = form && form.firstElementChild;
    if (!form || !nameInput || !flow) return;

    if (!flow.classList.contains('ps-personalization-flow')) flow.classList.add('ps-personalization-flow');

    [
      ['first-name', 'ps-field--name'],
      ['translation', 'ps-field--translation'],
      ['binding-type', 'ps-field--binding'],
      ['is-cover-message', 'ps-field--cover'],
      ['is-gift-note', 'ps-field--gift']
    ].forEach(function (field) {
      var input = form.querySelector('[name="' + field[0] + '"]');
      var group = directChildContaining(flow, input);
      if (group && !group.classList.contains(field[1])) {
        group.classList.add('ps-personalization-field', field[1]);
      }
    });

    var nameGroup = directChildContaining(flow, nameInput);
    var nameHeading = nameGroup && nameGroup.querySelector('.field-header');
    if (nameHeading) {
      nameHeading.id = nameHeading.id || 'ps-recipient-name-label';
      nameInput.setAttribute('aria-labelledby', nameHeading.id);
    } else {
      nameInput.setAttribute('aria-label', 'Recipient first name for the interior pages');
    }
    nameInput.setAttribute('autocomplete', 'off');

    function updatePreviewLabel() {
      var preview = document.querySelector('#ps-product-interface button.ps-preview');
      if (!preview) return;
      var firstName = nameInput.value.trim().split(/\s+/)[0];
      var label = firstName ? 'Preview ' + firstName + ' in Scripture' : 'Preview a name in Scripture';
      if (preview.textContent !== label) preview.textContent = label;
      preview.setAttribute('aria-label', label);
    }

    if (!nameInput.dataset.psFlowBound) {
      nameInput.dataset.psFlowBound = 'true';
      var nameStarted = false;
      nameInput.addEventListener('input', function () {
        updatePreviewLabel();
        if (!nameStarted && nameInput.value.trim()) {
          nameStarted = true;
          track('personalization_name_started', { page_path: window.location.pathname });
        }
      });
    }

    var preview = document.querySelector('#ps-product-interface button.ps-preview');
    if (preview && !preview.dataset.psFlowBound) {
      preview.dataset.psFlowBound = 'true';
      preview.addEventListener('click', function () {
        track('personalization_preview_clicked', {
          has_name: !!nameInput.value.trim(),
          page_path: window.location.pathname
        });
      });
    }

    updatePreviewLabel();
  }

  // The preview is required before add to cart, so explain the sequence beside the buttons.
  function addHint() {
    var prev = document.querySelector('#ps-product-interface button.ps-preview');
    if (!prev || document.querySelector('.ps-flow-hint')) return;
    var hint = document.createElement('p');
    hint.className = 'ps-flow-hint';
    hint.innerHTML = '<strong>See it before you buy.</strong> Preview the name in Scripture, then add it to your cart.';
    var row = prev.parentElement;            // the div holding PREVIEW + ADD TO CART side by side on desktop
    row.parentNode.insertBefore(hint, row);
  }
  preparePersonalizationFlow();
  addHint();
  var shown = false;
  var obs = new MutationObserver(function () {
    preparePersonalizationFlow();
    addHint();
    var open = !!document.querySelector('.ReactModal__Content--after-open');
    if (open) {
      if (!bar) build();
      if (!bar.classList.contains('is-visible')) { bar.classList.add('is-visible'); if (!shown) { shown = true; track('preview_bar_view'); } }
    } else if (bar && bar.classList.contains('is-visible')) {
      bar.classList.remove('is-visible');
    }
  });
  obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();

/* 2026-09-03 sticky "Personalize" button on phones: the personalisation form sits two screens below the carousel.
   Shows while the form is off-screen, hides when the form is visible or the preview lightbox / cart bar is open. */
(function () {
  if (!window.matchMedia('(max-width: 999px)').matches) return;
  // Customer Canvas renders its form asynchronously; wait for the name field (up to ~20 s).
  var tries = 0;
  var wait = setInterval(function () {
    var name = document.querySelector('input[name="first-name"]');
    if (name) { clearInterval(wait); init(name); }
    else if (++tries > 100) { clearInterval(wait); }
  }, 200);
  function init(name) {
  var form = document.querySelector('#ps-product-interface') || name.closest('form') || name.parentElement;
  var media = document.querySelector('.product__media');
  var btn = document.createElement('button');
  btn.type = 'button'; btn.className = 'button button--primary ps-sticky-personalize'; btn.textContent = 'Personalize yours';
  btn.setAttribute('aria-label', 'Jump to the personalization form');
  document.body.appendChild(btn);
  btn.addEventListener('click', function () {
    name.scrollIntoView({ block: 'center', behavior: 'smooth' });
    setTimeout(function () { try { name.focus({ preventScroll: true }); } catch (e) {} }, 500);
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'sticky_personalize_click' }); if (window.psGa4Event) window.psGa4Event('sticky_personalize_click', {}); } catch (e) {}
  });
  var formVisible = false;
  var mediaVisible = true;
  var io = new IntersectionObserver(function (entries) { entries.forEach(function (e) { formVisible = e.isIntersecting; update(); }); }, { threshold: 0.05 });
  io.observe(form);
  var mediaIo = null;
  if (media) {
    mediaIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { mediaVisible = e.isIntersecting; update(); });
    }, { threshold: 0.05 });
    mediaIo.observe(media);
  }
  function update() {
    var lightbox = !!document.querySelector('.ReactModal__Content--after-open');
    var bar = document.querySelector('.preview-cart-bar.is-visible');
    btn.classList.toggle('is-visible', !mediaVisible && !formVisible && !lightbox && !bar);
  }
  new MutationObserver(update).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  update();
  }
})();
